import { ThemedColors } from '../typings'

const baseThemeFor = (): ThemedColors => require('./optum').default

export default baseThemeFor
